import { track } from "@core/tracking";
var trackLogout = function() {
    track("logout");
};
export var AuthenticationTracking = {
    trackLogout: trackLogout
};

//# sourceMappingURL=AuthenticationTracking.js.map